import React from 'react';
import type { ListFilterState } from '../types';

// @ts-expect-error FIXME(strictNullChecks)
const Context = React.createContext<ListFilterState<any>>(null);

export const ListStateContextProvider = Context.Provider;

export const useListStateContext = () => {
  return React.useContext(Context);
};
